import { PlaceActionType } from './place-action-type';
import { PlaceEntry } from '../../state';

export interface SetPlacePosterImagesAction {
  placeKey: string;
  posterImages: PlaceEntry['place']['posterImages'];
  type: PlaceActionType.SetPlacePosterImages;
}

export const setPlacePosterImages = (
  placeKey: string,
  posterImages: PlaceEntry['place']['posterImages'],
): SetPlacePosterImagesAction => ({
  placeKey,
  posterImages,
  type: PlaceActionType.SetPlacePosterImages,
});
